export default __webpack_public_path__ + "static/media/Scrutinizers-Report-and-Voting-Results.f8404d56.pdf";